(ns machtfit.feedback
  (:require [machtfit.app.routes :as routes]
            [machtfit.translation :refer [t]]
            [machtfit.utils :as utils]
            [machtfit.widgets.icon :as icon]
            [re-frame.core :as rf]
            [reitit.frontend]))

(defn feedback-button
  [{:keys [survey query-params ui-id hide-on-small?]}]
  (let [survey-url (utils/build-questionpro-url survey query-params)]
    [:div.fixed.right-0.items-center.justify-center.w-8.md:w-11
     {:class (into ["top-1/2" "-translate-y-1/2" "z-[1000]"]
                   (if hide-on-small?
                     ["hidden" "md:flex"]
                     ["flex"]))}
     [:a.flex.items-center.bg-brand-500.hover:bg-brand-600.text-white.no-underline.font-bold.text-base.md:text-lg.-rotate-90.rounded-t-md.px-4.py-1.md:py-2.md:hover:pb-4.duration-150.ease-out.whitespace-nowrap
      {:href survey-url
       :target "_blank"
       :rel "noopener noreferrer"
       :data-ph-capture-attribute-ui_id ui-id
       :class ["gap-2.5" "transition-[padding]"]}
      [icon/outline "message-smile-square" {:height "h-6"
                                            :width "w-6"
                                            :class "rotate-90 hidden md:block"}]
      [t {:de "Feedback"
          :en "Feedback"}]]]))

(defn feedback-button-spa []
  (let [company-name @(rf/subscribe [:get [:user :company-name]])
        subdomain @(rf/subscribe [:get [:subdomain]])
        {page-id :id subpage :subpage} @(rf/subscribe [:get [:ui :page]])
        stepchall? (= page-id :stepchall)
        page-name (when page-id
                    (cond-> (name page-id)
                      subpage (str "-" (name subpage))))
        route-name (some-> (reitit.frontend/match-by-path routes/router
                                                          js/window.location.pathname)
                           (get-in [:data :name :id])
                           name)
        bgm-info? (contains? #{"bgm-info" "bgm-info-list" "bgm-info-detail"} route-name)]
    (when-not bgm-info?
      [feedback-button {:survey "feedback-button"
                        :ui-id "feedback-button"
                        :query-params {:customer company-name
                                       :sub subdomain
                                       :page_source (or page-name route-name "static")}
                        :hide-on-small? stepchall?}])))
